import { render, staticRenderFns } from "./BatchBaseInfo.vue?vue&type=template&id=9f8aaa28&scoped=true&"
import script from "./BatchBaseInfo.vue?vue&type=script&lang=js&"
export * from "./BatchBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./BatchBaseInfo.vue?vue&type=style&index=0&id=9f8aaa28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8aaa28",
  null
  
)

export default component.exports